<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import Overlay from '../components/overlay.svelte';
	import Plus from '$lib/icons/plus.svelte';
	import PageGrid from '../components/pageGrid.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: ISbStoryData[];
			title: ISbRichtext;
			text: ISbRichtext;
			button_label: string;
			overlay: ISbStoryData[];
			desktop_align: 'image_left' | 'image_right';
		}>['content'];
	}

	let { content }: Props = $props();

	let overlay = $state<{ show: () => void }>();
</script>

<PageGrid>
	<div
		class="col-span-full flex flex-col rounded-2xl max-lg:bg-stone-4 lg:col-start-2 lg:col-end-12 lg:gap-x-[18px] {content.desktop_align ===
		'image_right'
			? 'lg:flex-row-reverse'
			: 'lg:flex-row'}"
		use:editable={content}
	>
		<div
			class="overflow-hidden max-lg:h-52 lg:aspect-4/3 lg:flex-1 lg:rounded-[20px] lg:bg-stone-4"
		>
			<Blok fit="contain" content={content.asset[0]} />
		</div>
		<div
			class="flex flex-col items-center justify-center text-center text-brown-2 max-lg:mx-3 max-lg:mt-4 lg:flex-1 lg:text-left"
		>
			<div class="flex flex-col items-center lg:items-start lg:p-13">
				<div class="text-balance text-[24px]/[110%] font-semibold">
					<SbRichtext text={content.title} />
				</div>
				<div class="mt-2 text-balance text-[18px]/[140%] lg:mt-3">
					<SbRichtext text={content.text} />
				</div>
				<div class="mb-6 mt-3 lg:mt-6">
					<button
						onclick={() => overlay?.show()}
						class="flex h-12 items-center gap-x-2 rounded-full border border-brown-2 px-5 text-[18px]/[110%] text-brown-2 transition-colors hover:border-green-3 hover:bg-green-3 hover:text-stone-5"
					>
						{content.button_label}
						<Plus class="h-5 w-5" />
					</button>
				</div>
			</div>
		</div>
	</div>
</PageGrid>

{#if content.overlay[0]}
	<Overlay bind:this={overlay}>
		<Blok content={content.overlay[0]} />
	</Overlay>
{/if}
